"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSHSCardComponent = void 0;
const primarycard_component_1 = require("../primarycard.component");
const _ = require("underscore");
class CSHSCardComponent extends primarycard_component_1.CSPrimaryCardComponent {
    ngOnInit() {
        this.getStates();
        this.getSavedCardDetails(true);
        this.getBillingAddress();
        this.getPaymentMethod();
        // adding code for PCI compliance
        this.getTokenServiceErrorJson();
    }
    // Fetch US States
    getStates() {
        this.loader = true;
        this.accountDetailService.getAllStatesList().subscribe((data) => {
            this.loader = false;
            this.stateList = data;
        }, (err) => {
            this.loader = false;
        });
    }
    // Fetch Saved card
    getSavedCardDetails(recall) {
        this.loader = true;
        this.accountService.getPrimarySavedCardsHS(recall).subscribe((res) => {
            this.cardDetails = res;
            this.cardDetails = _.sortBy(this.cardDetails, 'defaultCard').reverse();
            this.loader = false;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    // Edit saved card
    saveEditSavedCard() {
        let ccAddressLine1;
        let ccCity;
        let ccState;
        let ccZip;
        const name = this.cardData.name.split(' ');
        const fName = name[0];
        const lName = name[1];
        if (this.cardData.creditCard.addressType === 'NEW') {
            ccAddressLine1 = this.cardData.creditCard.addressLine1;
            ccCity = this.cardData.creditCard.city;
            ccState = this.cardData.creditCard.state;
            ccZip = this.cardData.creditCard.zipCode;
        }
        else {
            ccAddressLine1 = this.address.addressLine1;
            ccCity = this.address.city;
            ccState = this.address.state;
            ccZip = this.address.zip;
        }
        if (this.save_ad === 'yes') {
            const content = {
                creditCardNumber: this.payment.creditCardNumber,
                creditCardType: this.payment.creditCardType,
                creditCardDetailId: this.payment.creditCardId,
                addressLine1: ccAddressLine1,
                addressLine2: '',
                city: ccCity,
                state: ccState,
                zipcode: ccZip,
                kHash: this.payment.kHashToken,
                firstName: fName,
                lastName: lName,
                defaultCard: this.cardData.creditCard.defaultCard,
                cardExpMonth: this.cardData.creditCard.expMonth,
                cardExpYear: this.cardData.creditCard.expYear
            };
            this.loader = true;
            this.error = '';
            this.accountService.saveEditCardDetailsHS(content).subscribe((res) => {
                this.getPaymentMethod();
                this.getSavedCardDetails();
            }, (err) => {
                this.loader = false;
                this.error = err;
            });
        }
    }
    // Saved the popup input field data
    savePopupData(formData) {
        if (this.save_ad !== 'yes') {
            this.newCardData = this.cardData;
            this.newCardData.creditCard.ccType = this.tokenService.getCardType(this.newCardData.creditCard.ccNumber);
            // new card add after Review edit
            this.edit = 'no';
            this.cvvBox = 'true';
            this.clearCvv();
            this.saveNewCard();
        }
        else {
            this.edit = 'no';
            this.saveEditSavedCard();
        }
        this.save_ad = 'no';
        this.modalReference.close();
    }
    // Delete saved card
    deleteCard() {
        this.loader = true;
        this.error = '';
        this.accountService.deleteSavedCardHS(this.deleteId).subscribe((res) => {
            this.modalReference.close();
            this.getPaymentMethod();
            this.getSavedCardDetails();
        }, (err) => {
            this.loader = false;
            this.error = err;
            this.modalReference.close();
        });
    }
    saveCardDetails(content) {
        this.loader = true;
        this.accountService.saveNewCardHS(content).subscribe((res) => {
            this.loader = false;
            this.getPaymentMethod();
            this.getSavedCardDetails();
        }, (err) => {
            this.loader = false;
            this.error = err;
        });
    }
    // Fetching Billing address
    getBillingAddress() {
        this.loader = true;
        this.payByDiffCcardAddr = 'billingAddr';
        this.accountService.getPersonalInformationHS().subscribe((res) => {
            this.loader = false;
            this.sameBillingAddress = res;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    getCreditCardToken(creditCardData, bearerToken, ccAddress, sameAsBillingAddress) {
        // calling payment token service
        this.loader = true;
        // converting expYear from string to Int
        this.tokenService.getPaymentToken(creditCardData, bearerToken, this.paymentUrl).subscribe((resp) => {
            this.loader = false;
            const content = {
                creditCardNumber: resp.token,
                creditCardType: this.newCardData.creditCard.ccType,
                cvv: this.newCardData.creditCard.cvv,
                addressLine1: ccAddress.address1,
                addressLine2: '',
                city: ccAddress.city,
                state: ccAddress.state,
                zipcode: ccAddress.zip,
                kHash: resp.khash,
                firstName: ccAddress.firstName,
                lastName: ccAddress.lastName,
                defaultCard: this.newCardData.creditCard.defaultCard,
                cardExpMonth: this.newCardData.creditCard.expMonth,
                cardExpYear: this.newCardData.creditCard.expYear
            };
            // calling save card details API
            this.saveCardDetails(content);
        }, (err) => {
            this.loader = false;
            this.getTokenServiceErrorMessage(err);
            this.helperService.scroll('errorMsg');
        });
    }
    // Saaving New card
    saveNewCard() {
        let SameAsBillingAddr;
        let billingAddress;
        let billingCity;
        let billingState;
        let billingZip;
        const name = this.cardData.name.split(' ');
        const fName = name[0];
        const lName = name[1];
        if (this.newCardData.creditCard.addressType === 'NEW') {
            SameAsBillingAddr = false;
            billingAddress = this.newCardData.creditCard.addressLine1;
            billingCity = this.newCardData.creditCard.city;
            billingState = this.newCardData.creditCard.state;
            billingZip = this.newCardData.creditCard.zipCode;
        }
        else {
            billingAddress = this.sameBillingAddress.billingAddress.addressLine1;
            billingCity = this.sameBillingAddress.billingAddress.city;
            billingState = this.sameBillingAddress.billingAddress.state;
            billingZip = this.sameBillingAddress.billingAddress.zip;
            SameAsBillingAddr = true;
        }
        // calling oAuthToken service
        this.loader = true;
        this.error = '';
        this.tokenService.getOauthAccessToken().subscribe((data) => {
            this.loader = false;
            this.oauthAccessToken = data.accessToken;
            this.paymentUrl = data.paymentTokenUrl;
            const bearerToken = 'Bearer ' + this.oauthAccessToken;
            const addressJson = {
                city: billingCity,
                state: billingState,
                zip: billingZip,
                address1: billingAddress,
                firstName: fName,
                lastName: lName
            };
            const paymentJson = {
                creditCardNumber: this.newCardData.creditCard.ccNumber,
                expirationMonth: this.newCardData.creditCard.expMonth,
                // converting card expYear from string to Int
                expirationYear: parseInt(this.newCardData.creditCard.expYear, 10),
                cvv: this.newCardData.creditCard.cvv
            };
            const creditCardData = this.tokenService.getCreditCardRequest(paymentJson, addressJson, 0);
            // calling payment token service
            this.getCreditCardToken(creditCardData, bearerToken, addressJson, SameAsBillingAddr);
        }, (err) => {
            this.loader = false;
            this.error = err;
        });
    }
    // adding code for PCI compliance
    getTokenServiceErrorJson() {
        this.tokenService.getCSErrorMessage().subscribe((res) => {
            this.tokenErrorMessage = res;
        }, (err) => {
        });
    }
    getPaymentMethod() {
        this.loader = true;
        this.accountDetailService.getPaymentMethodInformation().subscribe((info) => {
            this.paymentDetails = info;
            this.loader = false;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
}
exports.CSHSCardComponent = CSHSCardComponent;
//# sourceMappingURL=hscard.component.js.map